module.exports = __webpack_public_path__ + "static/media/YM44_1.69ef9d13.jpg";